import React, { useEffect, useRef, useState } from "react";
import "./Slider.css";
import { Link } from "react-router-dom";

const slides = [
  {
    id: 1,
    subtitle: "TRAVEL SIMPLIFIED",
    title1: "Discover the World",
    title2: "Your Way",
    desc: "We connect buyers and suppliers across the globe with cutting-edge travel solutions. From hotels and airlines to car rentals and cruises, our platform enables seamless journeys for businesses and travelers.",
    btn1Text: "Get Started",
    btn1Link: "/get-started",
    // btn2Text: "Explore Services",
    // btn2Link: "/services",
    image: "https://images.pexels.com/photos/33992405/pexels-photo-33992405.jpeg", // placeholder airplane image
  }, {
    id: 2,
    subtitle: "SPIRITUAL JOURNEY",
    title1: "Sacred Pilgrimage:",
    title2: "Umrah",
    desc: "Plan your sacred pilgrimage with trusted guidance and care. We offer comprehensive packages to make your spiritual journey seamless and memorable.",
    btn1Text: "Plan Umrah",
    btn1Link: "#umrah",
    // btn2Text: "Explore Services",
    // btn2Link: "/services",
    image: "https://images.pexels.com/photos/26436662/pexels-photo-26436662.jpeg",
  },
  {
    id: 3,
    subtitle: "LUXURY STAYS",
    title1: "Experience Ultimate",
    title2: "Comfort",
    desc: "Find and book the perfect hotel for relaxation and comfort. We partner with the best luxury hotels around the world to ensure your stay is memorable and relaxing.",
    btn1Text: "View Hotels",
    btn1Link: "/services/hotels",
    // btn2Text: "Explore Services",
    // btn2Link: "/services",
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=2070&auto=format&fit=crop",
  },
  {
    id: 4,
    subtitle: "ADVENTURE AWAITS",
    title1: "Curated Tours Just",
    title2: "For You",
    desc: "Discover our exclusive tour packages designed to suit every kind of travel dream. Whether you are looking for an adventurous trek or a relaxing beach holiday, we have it all.",
    btn1Text: "Discover Tours",
    btn1Link: "/services/packages",
    // btn2Text: "Explore Services",
    // btn2Link: "/services",
    image: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=2021&auto=format&fit=crop",
  },
 
];

const Slider = () => {
  const trackRef = useRef();
  const [current, setCurrent] = useState(0);
  const total = slides.length;
  const intervalRef = useRef();

  // Smooth infinite loop by duplicating slides
  const extendedSlides = [...slides, ...slides];

  useEffect(() => {
    const track = trackRef.current;
    const slideWidth = 100;

    const moveSlide = () => {
      let nextIndex = current + 1;
      setCurrent(nextIndex);

      track.style.transition = "transform 1s ease-in-out";
      track.style.transform = `translateX(-${nextIndex * slideWidth}%)`;

      if (nextIndex === total) {
        setTimeout(() => {
          track.style.transition = "none";
          track.style.transform = `translateX(0%)`;
          setCurrent(0);
        }, 1000);
      }
    };

    intervalRef.current = setInterval(moveSlide, 5000);
    return () => clearInterval(intervalRef.current);
  }, [current, total]);

  const goToSlide = (index) => {
    const track = trackRef.current;
    clearInterval(intervalRef.current);
    track.style.transition = "transform 1s ease-in-out";
    track.style.transform = `translateX(-${index * 100}%)`;
    setCurrent(index);
  };

  const prevSlide = () => {
    const track = trackRef.current;
    let prev = current - 1;
    if (prev < 0) prev = total - 1;

    track.style.transition = "transform 1s ease-in-out";
    track.style.transform = `translateX(-${prev * 100}%)`;
    setCurrent(prev);
    clearInterval(intervalRef.current);
  };

  const nextSlide = () => {
    const track = trackRef.current;
    let next = current + 1;
    track.style.transition = "transform 1s ease-in-out";
    track.style.transform = `translateX(-${next * 100}%)`;
    setCurrent(next === total ? 0 : next);
    clearInterval(intervalRef.current);
  };

  return (
    <div className="travelSlider">
      <div className="travelSlider-track" ref={trackRef}>
        {extendedSlides.map((slide, idx) => (
          <div key={idx} className="travelSlider-slide">
            <div
              className="travelSlider-bg"
              style={{ backgroundImage: `url(${slide.image})` }}
            />
            <div className="travelSlider-overlay" />
            <div className="travelSlider-content">
              <div className="subtitle-container">
                <div className="line"></div>
                <span className="subtitle">{slide.subtitle}</span>
                <span className="star">✦</span>
              </div>
              <h1 className="title">
                <span className="title-part-1">{slide.title1}</span><br />
                <span className="title-part-2">{slide.title2}</span>
              </h1>
              <p className="description">{slide.desc}</p>
              <div className="button-group">
                <Link to={slide.btn1Link} className="btn-primary">
                  {slide.btn1Text} &rarr;
                </Link>
                {/* <Link to={slide.btn2Link} className="btn-secondary">
                  <span className="play-icon">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="11" stroke="#de521f" strokeWidth="2"/>
                      <path d="M10 8L16 12L10 16V8Z" fill="#de521f"/>
                    </svg>
                  </span>
                  {slide.btn2Text}
                </Link> */}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Arrows */}
      <div className="travelSlider-arrows">
        <span className="arrow left" onClick={prevSlide}>
          ❮
        </span>
        <span className="arrow right" onClick={nextSlide}>
          ❯
        </span>
      </div>

      {/* Dots */}
      <div className="travelSlider-dots">
        {slides.map((_, idx) => (
          <span
            key={idx}
            className={`dot ${idx === current ? "active" : ""}`}
            onClick={() => goToSlide(idx)}
          />
        ))}
      </div>
    </div>
  );
};

export default Slider;
